export default __webpack_public_path__ + "static/makarony-544aa7bf0db97c7d93c213f5a3a28317.png";